import { useParams, Link } from 'react-router-dom';
import { getGameById, getModsForGame } from '../data/mods';
import './GamePage.css';

function GamePage() {
  const { gameId } = useParams();
  const game = getGameById(gameId);
  const mods = getModsForGame(gameId);

  if (!game) {
    return (
      <div className="game-page">
        <div className="not-found">
          <h1>Game Not Found</h1>
          <p>The game you're looking for doesn't exist.</p>
          <Link to="/" className="back-link">Back to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="game-page">
      <div className="game-header">
        <Link to="/" className="back-link">Back to Games</Link>
        <h1>{game.name} Mods</h1>
        <p>{game.description}</p>
      </div>

      {mods.length === 0 ? (
        <div className="no-mods">
          <p>No mods available for this game yet.</p>
        </div>
      ) : (
        <div className="mods-grid">
          {mods.map(mod => (
            <Link
              to={`/game/${gameId}/mod/${mod.id}`}
              key={mod.id}
              className="mod-card"
            >
              <div className="mod-card-image">
                {mod.thumbnail ? (
                  <img src={mod.thumbnail} alt={mod.name} />
                ) : (
                  <div className="mod-card-placeholder">{mod.name[0]}</div>
                )}
              </div>
              <div className="mod-card-content">
                <h3>{mod.name}</h3>
                <p className="mod-description">{mod.shortDescription}</p>
                <div className="mod-meta">
                  <span className="mod-version">v{mod.version}</span>
                  {mod.tags && mod.tags.length > 0 && (
                    <div className="mod-tags">
                      {mod.tags.slice(0, 2).map(tag => (
                        <span key={tag} className="mod-tag">{tag}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default GamePage;
